import { createContext, useContext } from 'react';

export interface IContext {
    /** Текущий путь к данным */
    currentPath: string;
}

export const CurrentPathContext = createContext<IContext>({ currentPath: '' });

export const useCurrentPathContext = () => useContext(CurrentPathContext);
